<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height align-start>
        <v-row>
          <v-col  md="12" lg="12" cols="12">
            <v-card>
              <v-card-title>Reportes</v-card-title>
              <v-card-subtitle>Contactos</v-card-subtitle>
              <v-card-text>

                <v-row>
                  <v-col md="3" lg="3" cols="6">
                    <v-autocomplete v-model="eventoId" :items="eventos" item-text="nombre" item-value="id"  label="Escoger Evento">
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="12" md="12" sm="12" cols="12">
                    <v-sparkline
                        :labels="labels"
                        :value="horas"
                        label-size="3"
                        show-labels=true
                        color="white"
                        smooth="10"
                        line-width="2"
                        padding="16"
                    ></v-sparkline>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col lg="12" md="12" sm="12" cols="12">
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row >
          <v-col md="12" lg="12" cols="12">
            <v-data-table       :headers="headers"
                                :items="reporte"
                                class="elevation-1"
                                item-key="idPromotor"
                                :loading="progr"
                                no-data-text="No hay datos disponibles para mostrar."
                                no-results-text="No hay resultados para la búsqueda."
                                loading-text="Cargando... Por favor espere."
                                style="background-color: #393E46;"
            >

            </v-data-table>
          </v-col>
        </v-row>
        <leftmenueventos :abreviado="abreviado" />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import Leftmenueventos from "@/components/general/leftmenueventos";
import axios from 'axios';

export default {
  components: {
    Leftmenueventos  },
  data: () => ({
    drawer: null,
    idnegocio: 0,
    fiestas:[],
    reporte:[],
    labels:[],
    horas:[],
    progr:true,
    eventoId: 0,
    fecha: null,
    menu1: false,
    abreviado:'NN',

    date: new Date().toISOString().substr(0, 10),
    chartData: {
      type: Object,
      default: null
    },
    headers: [
      { text: 'Promotor', value: 'promotor_nombre', sortable: true },
      { text: 'Tipo de Lista', value: 'tipo_lista_nombre', sortable: true },
      { text: 'Cabeza',  value: 'promotor_cabeza_nombre'},
      { text: 'Ingresaron', value: 'cantidad', sortable: true },
      { text: 'En Lista', value: 'total', sortable: true },
      { text: 'Porcentaje', value: 'porcentaje', sortable: false }
    ]
  }),
  mounted (){
    if (this.usuario.id === undefined){
      this.$router.push({ name: 'homepage' });
    }else{
      this.dameEventos();
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
    }
  },
  methods : {
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    dameEventos(){
      let urltempor = 'eventos/cliente/' + this.cliente.id  ;
      this.overlay = true
      this.progr = true
      axios
          .get(urltempor)
          .then(response => {
            this.eventos = response.data;
            this.eventoId = this.eventos[0].id
            this.overlay = false
            this.progr = false;
          })
          .catch((error)  => {
            this.error = error
            this.overlay = false
            this.progr = false;
          });
    },

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
};
</script>